import type { Locale } from '@estimating/i18n';
import { createRequiredContext } from '../../shared/create-required-context';

export interface LocaleContextValue {
  readonly locale: Locale;
  /** Only the locales the current brand offers (D-021). */
  readonly supportedLocales: readonly Locale[];
  readonly setLocale: (locale: Locale) => void;
}

export const [LocaleContext, useLocale] =
  createRequiredContext<LocaleContextValue>('LocaleContext');
